import { create } from "zustand";
import { persist } from "zustand/middleware";

type LocationSelection = string | "all";

interface LocationState {
  /** null = not yet initialized (waiting for useLocations to load) */
  currentLocationId: LocationSelection | null;
  setLocation: (id: LocationSelection) => void;
  clear: () => void;
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      currentLocationId: null,
      setLocation: (id) => set({ currentLocationId: id }),
      clear: () => set({ currentLocationId: null }),
    }),
    { name: "stockuj.location" },
  ),
);
